import { setBaseUrl } from '../request';

export type Env = 'production' | 'development' | 'staging';

let config!: InitParam;
export interface InitParam {
    env: Env;
    sid: string;
    appName: string;
    baseUrl: string;
    callback: string;
    language?: string;
}

/**
 * 设置语言参数
 * @param language
 */
export function setLanguage(language: string) {
    config.language = language;
}

export function init(params: InitParam): void {
    const {
        sid,
        callback,
        env = 'production',
    } = params;
    config = {
        ...config,
        sid,
        env,
        appName: params.appName,
        baseUrl: params.baseUrl,
        callback: callback || location.href,
        language: params.language,
    };
    setBaseUrl(config.baseUrl);
}

export function getConfig(): InitParam {
    return config;
}
